import { render, staticRenderFns } from "./SelectedProductOverviewCard.vue?vue&type=template&id=c0fdbcb2&scoped=true&"
import script from "./SelectedProductOverviewCard.vue?vue&type=script&lang=js&"
export * from "./SelectedProductOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductOverviewCard.vue?vue&type=style&index=0&id=c0fdbcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fdbcb2",
  null
  
)

export default component.exports